import { render, staticRenderFns } from "./CodeType.vue?vue&type=template&id=b634d7bc&"
import script from "./CodeType.vue?vue&type=script&lang=js&"
export * from "./CodeType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports